export default {
    translations: {
        menu: {
            home: 'Home',
            about: 'Sobre',
            support_us: 'Experiências',
            join_us: 'Faça parte',
            upcoming_events: "Próximos eventos",
            team: 'Habilidades',
            social_network: 'Redes sociais',
        },
        section_home: {
            title: "DON'T WORK HARD, WORK SMART!",
            button: "Mais sobre mim",
        },
        section_about: {
            title: "Quem sou eu?",
            description: `Meu nome é Denis 'Velrino' Magalhães e tenho 26 anos.

            Desde 2015, tenho me envolvido com tecnologia.
            
            Desde criança, sempre tive uma paixão por tecnologia.
            
            Iniciei minha carreira como desenvolvedor full-stack, com o objetivo de compreender como tudo funciona (back-end, front-end e DevOps) para garantir consistentemente a criação de produtos de alta qualidade.
            
            Além do meu crescimento pessoal e profissional, tenho participado ativamente de eventos e aprendido com pessoas excepcionais.`,
            card_1_title: "ADORO WORKSHOPS",
            card_1_text: "Na minha opinião, os workshops são mais eficientes para o processo de aprendizagem daqueles que estão assistindo.",
            card_2_title: "CURSO NODEJS ​PARA INCIANTES",
            card_2_text: "Um dos maiores cursos online que já ajudou milhares de devs a entrarem no mercado",
            card_3_title: "NODEJS DO BÁSICO ​AO AVANÇADO",
            card_3_text: "Entregues de forma gratuita para a comunidade",
        },
        section_experiences: {
            title: "Experiências",
            button: "Nos apoie com sua empresa",
        },
        section_voluntary: {
            title: "Venha fazer parte da comunidade",
            button_1: "Seja voluntário(a)",
            button_2: "Parcerias",
        },
        section_skills: {
            title: "Habilidades",
        },
        section_social: {
            title: "redes sociais",
        },
        section_upcoming_events: {
            title: "Próximos eventos",
        },
    }
}